import $ from "jquery";

const MODAL_BACKDROP_ACTIVE_CLASS = 'modal-backdrop-color';

export const removeActiveBackdrop = () => {
    $('#modal-backdrop').removeClass(MODAL_BACKDROP_ACTIVE_CLASS);
};

export const addActiveBackdrop = () => {
    $('#modal-backdrop').addClass(MODAL_BACKDROP_ACTIVE_CLASS);
    $('#modal-backdrop').show();
};

export const hideBackground = () => {
    $('#modal-backdrop').hide();
};
